import { QueryClient } from '@tanstack/react-query'
import { ONE_MINUTE_IN_MS } from '../utils/constants'

const TEN_MINUTES_IN_MS = ONE_MINUTE_IN_MS * 10

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: ONE_MINUTE_IN_MS,
      gcTime: TEN_MINUTES_IN_MS,
    },
  },
})
